import { BasicModalWithTwoButtons } from '../Modal/BasicModalWithTwoButtons';
import { ModalBelow, itemOfModal } from '../Modal/ModalBelow';
import { SolarPauseIcon } from '../../assets/images/solar/Pause';
import { SolarRestartSquareIcon } from '../../assets/images/solar/RestartSquare';
import { SolarStopWatchPlayIcon } from '../../assets/images/solar/StopwatchPlay';
import { useStores } from '../../hooks/useStores';

interface ModalOfPathProps {
    isVisible: boolean;
    isActive: boolean;
    started: boolean;
    onPressUnfollow: () => void;
    onDismiss: () => void;
    setActivePath: () => void;
    goToChooseANewPath: () => void;
  }

export const ModalOfPath = ({ isVisible, isActive, started,  onPressUnfollow, onDismiss,setActivePath, goToChooseANewPath}: ModalOfPathProps) => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.PATH;
  const SIZE = 20;

  let modalItemPathState : itemOfModal | undefined = undefined;
  let modalItemActive : itemOfModal | undefined = undefined;


  if (started && !isActive) { // pause path
    modalItemPathState = {
      icon: <SolarPauseIcon  size={SIZE}/>,
      label:labels?.PAUSE_PATH,
      dismissOnPress: false,
      modal: (onDismissFromBelowModal : () => void) => {
        return (<>{modalStop(onDismissFromBelowModal)}</>);
      },
    };
  }

  if(isActive) {
    modalItemActive = {
      icon: <SolarRestartSquareIcon size={SIZE}/>,
      label:labels?.CHANGE_MY_CURRENT_PATH,
      dismissOnPress: false,
      modal: (onDismissFromBelowModal : () => void) => {
        return (<>{modalChangeCurrentPath(onDismissFromBelowModal)}</>);
      },
    };
  } else  {
    modalItemActive = {
      onPress: setActivePath,
      icon: <SolarStopWatchPlayIcon size={SIZE}/>,
      label:labels?.MAKE_IT_MY_CURRENT_PATH,
      dismissOnPress: true,
    };
  }





  const modalStop= (onDismissFromBelowModal: ()=> void) => {
    return (
      <BasicModalWithTwoButtons
        onDismiss={onDismissFromBelowModal}
        onMainAction={() => {
          onPressUnfollow();
          onDismissFromBelowModal();
        }}
        titleText={labels?.TITLE_BEFORE_STOP_MODAL}
        mainText={labels?.EXPLANATION_PAUSE}
        buttonDismissText={labels?.CANCEL_PATH}
        buttonMainActionText={labels?.PAUSE_PATH}
      />
    );
  };

  const modalChangeCurrentPath= (onDismissFromBelowModal: ()=> void) => {
    return (
      <BasicModalWithTwoButtons
        onDismiss={onDismissFromBelowModal}
        onMainAction={() => {
          goToChooseANewPath();
          onDismissFromBelowModal();
        }}
        titleText={labels?.CHANGE_CURRENT_PATH_MODAL_TITLE}
        mainText={labels?.CHANGE_CURRENT_PATH_MODAL_CONTENT}
        buttonDismissText={labels?.CHANGE_CURRENT_PATH_MODAL_DECLINE}
        buttonMainActionText={labels?.CHANGE_CURRENT_PATH_MODAL_CONFIRM}
      />
    );
  };

  const items = [modalItemPathState, modalItemActive].filter(x=> x) as itemOfModal[];



  return (<>
    <ModalBelow isVisible={isVisible} onDismiss={onDismiss} labelBelow={labels?.CANCEL_BELOW_MODAL} items={items}/>
  </>);
};